import { fontFamilies, sizes } from '../../../glassConsts';
import React from 'react';
import { useConfig } from '../../ConfigContext';
import { designSlides } from '../Carousel/carouselData';

const PairControls = () => {
  const { general, setGeneralState, size } = useConfig();

  const pluginUrl = window.GBCONF ? window.GBCONF.pluginUrl : '';

  if (
    ['amp', 'heart', 'wedding'].includes(
      designSlides[general.selectedCarouselNameDesignIndex].name
    )
  ) {
    if (general.hasSecondaryText) setGeneralState({ hasSecondaryText: false });
  } else if (
    ['nameDate', 'nameLocation', 'nameLocationMap'].includes(
      designSlides[general.selectedCarouselNameDesignIndex].name
    )
  ) {
    if (!general.hasSecondaryText) setGeneralState({ hasSecondaryText: true });
  }

  let isLocation = false;
  isLocation = ['nameLocation', 'nameLocationMap'].includes(
    designSlides[general.selectedCarouselNameDesignIndex].name
  );

  return (
    <>
      <div
        style={{
          fontFamily: fontFamilies[general.font],
          fontSize: general.orientationHorizontal
            ? size.height / 28
            : size.height / 38,
          fontWeight: 'bold',
          color: general.color,
          textAlign: 'center',
          textShadow: '0 2px 8px rgba(0,0,0,0.15)',
          whiteSpace: general.mainTextBreak ? 'pre-line' : 'normal',
          lineHeight: '10px',
          wordBreak: 'break-word',
        }}
      >
        {general.mainText.length < 1
          ? 'Anet + Lukáš'
          : general.mainTextBreak && general.mainText.includes(' ')
            ? general.mainText.replace(' ', '\n')
            : general.mainText}
      </div>
      {general.hasSecondaryText && (
        <div
          className={`${designSlides[general.selectedCarouselNameDesignIndex].cssClass === 'nameLocationMap' ? 'pt-2' : ''} mobile_secondary flex items-center justify-center`}
          style={{
            fontFamily: fontFamilies[general.font],
            fontSize: general.orientationHorizontal
              ? size.height / 38
              : size.height / 50,
            color: general.color,
            opacity: 0.75,
            textAlign: 'center',
            marginTop: 5,
            wordBreak: 'break-word',
          }}
        >
          {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
            'nameLocationMap' && (
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size.height / 30}
                height={size.height / 30}
                viewBox="0 0 24 24"
                stroke="white"
                fill="white"
              >
                <g>
                  <path d="M12,2A7.008,7.008,0,0,0,5,9c0,5.353,6.036,11.45,6.293,11.707l.707.707.707-.707C12.964,20.45,19,14.353,19,9A7.008,7.008,0,0,0,12,2Zm0,16.533C10.471,16.825,7,12.553,7,9A5,5,0,0,1,17,9C17,12.546,13.527,16.823,12,18.533Z" />
                  <path d="M12,6a3,3,0,1,0,3,3A3,3,0,0,0,12,6Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,12,10Z" />
                </g>
              </svg>
            </div>
          )}
          {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
            'nameLocation' && (
            <span
              style={{
                display: 'block',
                marginTop: general.orientationHorizontal
                  ? -size.height / 38
                  : -size.height / 50,
                marginRight: 5,
              }}
            >
              ____
            </span>
          )}
          {general.secondaryText.length < 1
            ? isLocation
              ? 'Londýn'
              : '1.2.2020'
            : general.secondaryText}
          {designSlides[general.selectedCarouselNameDesignIndex].cssClass ===
            'nameLocation' && (
            <span
              style={{
                display: 'block',
                marginTop: general.orientationHorizontal
                  ? -size.height / 38
                  : -size.height / 50,
                marginLeft: 4,
              }}
            >
              ____
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default PairControls;
